// LabStatusChart.jsx
import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const COLORS = ["#1CDF03", "#1302FB", "#C607CA", "#FF7300"];

const LabStatusChart = ({ dashboardData }) => {
  const data = [
    { name: "SLIPTA Certified", value: dashboardData.sliptaCertified || 0 },
    { name: "SADCAS Level A", value: dashboardData.sadcasLevelA || 0 },
    { name: "SADCAS Level B", value: dashboardData.sadcasLevelB || 0 },
    { name: "HPCZ Licensed", value: dashboardData.licensedLabs || 0 },
  ];

  const renderLegend = () => (
    <div>
      {data.map((item, idx) => (
        <div
          key={idx}
          style={{ display: "flex", alignItems: "center", marginRight: "15px" }}
        >
          <div
            style={{
              width: 10,
              height: 10,
              backgroundColor: COLORS[idx],
              borderRadius: "50%",
              marginRight: 5,
            }}
          />
          <span style={{ fontSize: "14px" }}>
            {item.name} - {item.value}
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <div>
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={data}
            innerRadius={80}
            outerRadius={100}
            paddingAngle={1}
            cornerRadius={6}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name) => [`${value}`, name]}
            contentStyle={{ backgroundColor: "#fff", borderRadius: "5px", padding: "10px", border: "1px solid #ccc" }}
          />
        </PieChart>
      </ResponsiveContainer>
      <div className="d-flex flex-wrap justify-content-center mt-2">
        {renderLegend()}
      </div>
    </div>
  );
};

export default LabStatusChart;